import { Routes } from '@angular/router';
import { StockUnitSearchComponent } from './pages/stock/stock-unit-search/stock-unit-search.component';
import { UnitUpdateModalComponent } from './components/modals/unit-update/unit-update-modal';
import { MinimalLayoutComponent } from './minimal-layout/minimal-layout.component';
import { DealerSummaryComponent } from './pages/dealer-summary/dealer-summary.component';
import { NatisDocumentsComponent } from './pages/natis-documents/natis-documents.component';
import { AuthGuard } from './guards/auth.guard';
import { LandingComponent } from './pages/landing/landing.component';

export const routes: Routes = [
  {
    path: 'stock-unit-search',
    canActivate: [AuthGuard],
    component: StockUnitSearchComponent,
  },
  {
    path: 'unit-update',
    component: MinimalLayoutComponent,
    children: [
      {
        path: '',
        canActivate: [AuthGuard],
        component: UnitUpdateModalComponent,
      },
    ],
  },
  {
    path: 'dealer-summary',
    canActivate: [AuthGuard],
    component: DealerSummaryComponent,
  },
  {
    path: 'natis-documents',
    canActivate: [AuthGuard],
    component: NatisDocumentsComponent,
  },
  { path: 'landing', canActivate: [AuthGuard], component: LandingComponent },
  { path: '**', redirectTo: 'landing' },
];
